module.exports = __webpack_public_path__ + "static/Share-Image-9cb0e04feb8160cf5a3c42e6ceb13f58.png";